import { render, staticRenderFns } from "./skinPackageFour.vue?vue&type=template&id=492e26b6&scoped=true"
import script from "./skinPackageFour.vue?vue&type=script&lang=js"
export * from "./skinPackageFour.vue?vue&type=script&lang=js"
import style0 from "./skinPackageFour.vue?vue&type=style&index=0&id=492e26b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492e26b6",
  null
  
)

export default component.exports